
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".75","y":"1.295","width":"9.167","height":"9.167","rx":"3.75","stroke":"#E6E7E9","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":".75","y":"14.628","width":"9.167","height":"9.167","rx":"3.75","stroke":"#E6E7E9","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"14.086","y":"1.295","width":"9.167","height":"9.167","rx":"3.75","fill":"#E6E7E9","stroke":"#E6E7E9","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"14.086","y":"14.628","width":"9.167","height":"9.167","rx":"3.75","stroke":"#E6E7E9","stroke-width":"1.5"}})])
          )
        }
      }
    